// === 2024

// import PR_2 from '../docs/2024/PR_GRUPO_2.pdf';
// import PS_2 from '../docs/2024/PS_GRUPO_2.pdf';
// import GROUP_3 from '../docs/2024/GRUPO_3.pdf';
// import GROUP_4 from '../docs/2024/GRUPO_4.pdf';
// import GROUP_5 from '../docs/2024/GRUPO_5.pdf';

import GRUPO_2_2026 from '../docs/2026/GRUPO_2_2026.pdf';
import GRUPO_3_2026 from '../docs/2026/GRUPO_3_2026.pdf';
import GROUP_4_2026 from '../docs/2026/GRUPO_4_2026.pdf';
import GROUP_5_2026 from '../docs/2026/GRUPO_5_2026.pdf';


import RCBANCOSOL from '../docs/2024/RELATORIO/R_CBANCO_SOL.pdf'
import RCSOGESTER from '../docs/2024/RELATORIO/R_CSOGESTER.pdf'
import RCMULTIPLANOS from '../docs/2024/RELATORIO/R_CMULTIPLANOS.pdf'
import RCFUTURO from '../docs/2024/RELATORIO/R_CFUTURO.pdf'

// const List_2024 = [
// 	{
// 		Id: 1,
// 		Titulo: 'Lista de PR Grupo II',
// 		Cover: './img/list-img-2.jpg',
// 		Categoria: 'LISTA PR - 2024',
// 		Data: '27 Fevereiro 2024',
// 		link: PR_2,
// 	},

// 	{
// 		Id: 2,
// 		Titulo: 'Lista de PS Grupo II',
// 		Cover: './img/list-img-2.jpg',
// 		Categoria: 'LISTA PS - 2024',
// 		Data: '27 Fevereiro 2024',
// 		link: PS_2,
// 	},

// 	{
// 		Id: 3,
// 		Titulo: 'Lista do Grupo III',
// 		Cover: './img/list-img-2.jpg',
// 		Categoria: 'LISTA - 2024',
// 		Data: '27 Fevereiro 2024',
// 		link: GROUP_3,
// 	},

// 	{
// 		Id: 4,
// 		Titulo: 'Lista do Grupo IV',
// 		Cover: './img/list-img-2.jpg',
// 		Categoria: 'LISTA - 2024',
// 		Data: '27 Fevereiro 2024',
// 		link: GROUP_4,
// 	},

// 	{
// 		Id: 5,
// 		Titulo: 'Lista do Grupo V',
// 		Cover: './img/list-img-2.jpg',
// 		Categoria: 'LISTA - 2024',
// 		Data: '27 Fevereiro 2024',
// 		link: GROUP_5,
// 	},
// ];

export const List_2026 = [
	{
		Id: 1,
		Titulo: 'Lista de Beneficiários Grupo II',
		Cover: './img/list-img-2.jpg',
		Categoria: 'PROVA DE VIDA',
		Data: '20 Fevereiro 2026',
		link: GRUPO_2_2026,
	},

	{
		Id: 2,
		Titulo: 'Lista de Beneficiários Grupo III',
		Cover: './img/list-img-2.jpg',
		Categoria: 'PROVA DE VIDA',
		Data: '20 Fevereiro 2026',
		link: GRUPO_3_2026,
	},

	{
		Id: 3,
		Titulo: 'Lista de Beneficiários Grupo IV',
		Cover: './img/list-img-2.jpg',
		Categoria: 'PROVA DE VIDA',
		Data: '20 Fevereiro 2026',
		link: GROUP_4_2026,
	},

	{
		Id: 4,
		Titulo: 'Lista de Beneficiários Grupo V',
		Cover: './img/list-img-2.jpg',
		Categoria: 'PROVA DE VIDA',
		Data: '20 Fevereiro 2026',
		link: GROUP_5_2026,
	},


];

export const relatorio_2024 = [
	{
		Id: 1,
		Titulo: 'Relatório e Contas Fundos de Pensões do Banco Sol',
		Cover: './img/list-img-2.jpg',
		Categoria: 'RELATÓRIO E CONTAS',
		Data: '21 Julho 2025',
		link: RCBANCOSOL,
	},

	{
		Id: 2,
		Titulo: 'Relatório e Contas Fundos de Pensões da SOGESTER',
		Cover: './img/list-img-2.jpg',
		Categoria: 'RELATÓRIO E CONTAS',
		Data: '21 Julho 2025',
		link: RCSOGESTER,
	},

	{
		Id: 3,
		Titulo: 'Relatório e Contas Fundos de Pensões Multiplanos',
		Cover: './img/list-img-2.jpg',
		Categoria: 'RELATÓRIO E CONTAS',
		Data: '21 Julho 2025',
		link: RCMULTIPLANOS,
	},

	{
		Id: 4,
		Titulo: 'Relatório e Contas Futuro Fundo de Pensões',
		Cover: './img/list-img-2.jpg',
		Categoria: 'RELATÓRIO E CONTAS',
		Data: '21 Julho 2025',
		link: RCFUTURO,
	}
];

